import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminInvestors,
  createAdminInvestor,
  updateAdminInvestor,
  deleteAdminInvestor,
} from "../../api/admin/investors.api";

/* ================= FETCH ================= */

export const fetchInvestors = createAsyncThunk(
  "admin/investors/fetch",
  async ({ page = 1, limit = 10, search = "", status = "" }, { rejectWithValue }) => {
    try {
      const res = await getAdminInvestors({ page, limit, search, status });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

/* ================= CREATE ================= */

export const addInvestor = createAsyncThunk(
  "investors/addInvestor",
  async (payload, { rejectWithValue }) => {
    console.log("📡 ADD INVESTOR API CALL PAYLOAD:", payload);

    const res = await createAdminInvestor(payload);

    console.log("📥 ADD INVESTOR API RESPONSE:", res);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

/* ================= UPDATE ================= */
export const updateInvestor = createAsyncThunk(
  "admin/investors/update",
  async ({ id, investorData }, { rejectWithValue }) => {
    const res = await updateAdminInvestor(id, investorData);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

/* ================= DELETE ================= */
export const deleteInvestor = createAsyncThunk(
  "admin/investors/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteAdminInvestor(id);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return { id };
  }
);